import { OrderStatus } from "../types/order";
import { UangJalanReportStatus } from "../types/uangJalanReport";
import { UserRole, type User } from "../types/user";

const OPS_ORDER_STATUSES: OrderStatus[] = [
  OrderStatus.OPEN,
  OrderStatus.READY_FOR_REVIEW,
  OrderStatus.REVISION_REQUIRED,
];

const FINANCE_VERIFIER_ORDER_STATUSES: OrderStatus[] = [OrderStatus.IN_REVIEW];

const FINANCE_APPROVER_ORDER_STATUSES: OrderStatus[] = [
  OrderStatus.IN_REVIEW,
  OrderStatus.VERIFIED,
];

const OPS_REPORT_STATUSES: UangJalanReportStatus[] = [
  UangJalanReportStatus.OPEN,
  UangJalanReportStatus.REVISION_REQUIRED,
];

const FINANCE_VERIFIER_REPORT_STATUSES: UangJalanReportStatus[] = [UangJalanReportStatus.IN_REVIEW];

const FINANCE_APPROVER_REPORT_STATUSES: UangJalanReportStatus[] = [
  UangJalanReportStatus.IN_REVIEW,
  UangJalanReportStatus.VERIFIED,
];

const unique = <T extends string>(values: T[]): T[] => Array.from(new Set(values));

export const getActionRequiredOrderStatuses = (
  role: UserRole | string | undefined,
): OrderStatus[] => {
  switch (role) {
    case UserRole.STAFF_OPERATIONS:
      return [...OPS_ORDER_STATUSES];
    case UserRole.STAFF_FINANCE_VERIFIER:
      return [...FINANCE_VERIFIER_ORDER_STATUSES];
    case UserRole.STAFF_FINANCE_APPROVER:
      return [...FINANCE_APPROVER_ORDER_STATUSES];
    case UserRole.ADMIN:
    case UserRole.SUPERUSER:
      return unique([
        ...OPS_ORDER_STATUSES,
        ...FINANCE_VERIFIER_ORDER_STATUSES,
        ...FINANCE_APPROVER_ORDER_STATUSES,
      ]);
    default:
      return [];
  }
};

export const getActionRequiredReportStatuses = (
  role: UserRole | string | undefined,
): UangJalanReportStatus[] => {
  switch (role) {
    case UserRole.STAFF_OPERATIONS:
      return [...OPS_REPORT_STATUSES];
    case UserRole.STAFF_FINANCE_VERIFIER:
      return [...FINANCE_VERIFIER_REPORT_STATUSES];
    case UserRole.STAFF_FINANCE_APPROVER:
      return [...FINANCE_APPROVER_REPORT_STATUSES];
    case UserRole.ADMIN:
    case UserRole.SUPERUSER:
      return unique([
        ...OPS_REPORT_STATUSES,
        ...FINANCE_VERIFIER_REPORT_STATUSES,
        ...FINANCE_APPROVER_REPORT_STATUSES,
      ]);
    default:
      return [];
  }
};

export const getActionRequiredOrderStatusesForUser = (
  user: User | null | undefined,
): OrderStatus[] => {
  return getActionRequiredOrderStatuses(user?.role);
};

export const getActionRequiredReportStatusesForUser = (
  user: User | null | undefined,
): UangJalanReportStatus[] => {
  return getActionRequiredReportStatuses(user?.role);
};
